import React from 'react'
import { FaCircleCheck } from "react-icons/fa6";


function MainAboutUs({ details }) {
  return (
    <div className='main_about_us_main' >
      <div className="container">
        <div className="row main_about_us_row">
          <div className="col-sm-12 col-md-12 col-xl-5">
            <div className='main_about_image' >
              <img className='main_about_left_image_dummy' src="/images/find-bg.png" alt="img" />
              <img className="main_about_left_image" src="/images/aboutus.png" alt="img" />

            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-xl-7">
            <div className="main_about_right_main">
              <span>About Us</span>
              <h2>Welcome To Our Luxurious Properties,
                With All The Conveniences.</h2>
              <div
                dangerouslySetInnerHTML={{ __html: details }}
              ></div>
              <div className="col-12">
                <div className="row">
                  <div className="col-sm-12 col-xl-6 d-flex align-items-center my-2">
                    <FaCircleCheck />
                    <p className='m-0 px-2' >Lorem Ipsum is simply dummy text</p>
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-6 d-flex align-items-center my-2">
                    <FaCircleCheck />
                    <p className='m-0 px-2' >Lorem Ipsum is simply dummy text</p>
                  </div>
                  <div className="col-sm-12  col-md-6 col-xl-6 d-flex align-items-center my-2">
                    <FaCircleCheck />
                    <p className='m-0 px-2' >Lorem Ipsum is simply dummy text</p>
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-6 d-flex align-items-center my-2">
                    <FaCircleCheck />
                    <p className='m-0 px-2' >Lorem Ipsum is simply dummy text</p>
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-6 d-flex align-items-center my-2">
                    <FaCircleCheck />
                    <p className='m-0 px-2' >Lorem Ipsum is simply dummy text</p>
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-6 d-flex align-items-center my-2">
                    <FaCircleCheck />
                    <p className='m-0 px-2' >Lorem Ipsum is simply dummy text</p>
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-6 d-flex align-items-center my-2">
                    <FaCircleCheck />
                    <p className='m-0 px-2' >Lorem Ipsum is simply dummy text</p>
                  </div>
                  <div className="col-sm-12 col-md-6 col-xl-6 d-flex align-items-center my-2">
                    <FaCircleCheck />
                    <p className='m-0 px-2' >Lorem Ipsum is simply dummy text</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainAboutUs
